export enum Roles {
  DELIVERER = 'deliverer',
  PUBLIC_VIEWER = 'public',
  REQUESTER = 'requester',
  APPROVER = 'approver',
  OBSERVER = 'observer',
}
